import { Box } from '@mui/material'
import { Button } from '@ds/components'

interface RequestCardActionsProps {
  isExpanded: boolean
  loading: boolean
  onToggleExpand: () => void
}

export const RequestCardActions = ({
  isExpanded,
  loading,
  onToggleExpand,
}: RequestCardActionsProps) => {
  return (
    <Box sx={{ p: 2, pt: 0 }}>
      <Button
        size="small"
        onClick={onToggleExpand}
        disabled={loading}
        variant="contained"
        color="primary"
      >
        {(() => {
          if (loading) return 'Loading...'
          if (isExpanded) return 'Hide Details'
          return 'View Details & Songs'
        })()}
      </Button>
    </Box>
  )
}
